import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
  text-align: center;
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.highlight};
  margin-bottom: 2rem;
`;

const Contact = () => {
  return (
    <Container>
      <Title>Contact Us</Title>
      <p>Get in touch with the Sonna team any time at</p>
      <p>
        <a href="mailto:admin@sonna.co" style={{ color: '#4a90e2', textDecoration: 'none', fontWeight: 500 }}>
          admin@sonna.co
        </a>
      </p>
      <p>
        Or call us at <span style={{ fontWeight: 500 }}>1-866-710-1801</span>
      </p>
    </Container>
  );
};

export default Contact;
